/**
 * Copyright (c) Microsoft. All rights reserved.
 */

const getLink = (serviceName: string, linkType: 'api' | 'doc' | 'overview' | 'samples' | 'sdk') => {
    let link = `https://aka.ms/${serviceName}`;

    switch (linkType) {
        case 'api':
            link = `${link}-apireference`;
            break;
        case 'doc':
            link = `${link}-quickstart`;
            break;
        case 'overview':
            link = `${link}-overview`;
            break;
        case 'samples':
            link = `${link}-samples`;
            break;
        case 'sdk':
            link = `${link}-sdk`;
            break;
        default:
    }

    return link;
};

export const textAnalyticsPricingLink = 'https://aka.ms/unifiedLanguagePricing';
export const textAnalyticsReferenceBaseLink =
    'https://westus.dev.cognitive.microsoft.com/docs/services/TextAnalytics-v3-1-preview-3/operations/';
export const textAnalyticsSampleLink =
    'https://github.com/Azure/azure-sdk-for-python/tree/master/sdk/textanalytics/azure-ai-textanalytics/samples';

export const keyPhrasesApiReferenceLink = getLink('extract-kp', 'api');
export const keyPhrasesDocLink = getLink('extract-kp', 'doc');
export const keyPhrasesOverviewLink = getLink('extract-kp', 'overview');
export const keyPhrasesSamplesLink = getLink('extract-kp', 'samples');
export const keyPhrasesSdkLink = getLink('extract-kp', 'sdk');

export const linkedEntitiesApiReferenceLink = getLink('linkedEntities', 'api');
export const linkedEntitiesDocLink = getLink('linkedEntities', 'doc');
export const linkedEntitiesOverviewLink = getLink('linkedEntities', 'overview');
export const linkedEntitiesSamplesLink = getLink('linkedEntities', 'samples');
export const linkedEntitiesSdkLink = getLink('linkedEntities', 'sdk');

export const namedEntitiesApiReferenceLink = getLink('extractNamedEntities', 'api');
export const namedEntitiesDocLink = getLink('extractNamedEntities', 'doc');
export const namedEntitiesOverviewLink = getLink('extractNamedEntities', 'overview');
export const namedEntitiesSamplesLink = getLink('extractNamedEntities', 'samples');
export const namedEntitiesSdkLink = getLink('extractNamedEntities', 'sdk');

export const piiApiReferenceLink = getLink('extract-pii', 'api');
export const piiDocLink = getLink('extract-pii', 'doc');
export const piiOverviewLink = getLink('extract-pii', 'overview');
export const piiSamplesLink = getLink('extract-pii', 'samples');
export const piiSdkLink = getLink('extract-pii', 'sdk');

export const questionAnswersApiReferenceLink = 'https://aka.ms/prebuilt-question-answering-apis';
export const questionAnswersDocLink = 'https://aka.ms/PrebuiltQnADoc';
export const questionAnswersSamplesLink = 'https://aka.ms/PreviewQnASample';
export const questionAnswersSdkLink = 'https://aka.ms/PreviewQnAsdk';

export const generateQuestionsDocLink = 'https://aka.ms/QGenDocumentation';
export const generateQuestionsSamplesLink = 'https://aka.ms/QGenGitHubSamples';

export const sentimentApiReferenceLink = getLink('analyze-sentiment', 'api');
export const sentimentDocLink = getLink('analyze-sentiment', 'doc');
export const sentimentOverviewLink = getLink('analyze-sentiment', 'overview');
export const sentimentSamplesLink = getLink('analyze-sentiment', 'samples');
export const sentimentSdkLink = getLink('analyze-sentiment', 'sdk');

export const detectLanguageApiReferenceLink = getLink('language-detect', 'api');
export const detectLanguageDocLink = getLink('language-detect', 'doc');
export const detectLanguageOverviewLink = getLink('language-detect', 'overview');
export const detectLanguageSamplesLink = getLink('language-detect', 'samples');
export const detectLanguageSdkLink = getLink('language-detect', 'sdk');

export const translationPricingLink = 'https://azure.microsoft.com/pricing/details/cognitive-services/translator/';

export const textTranslationDocLink = '#';
export const textTranslationSDKLink = '#';
export const textTranslationReferenceLink = '#';
export const textTranslationSampleLink = 'https://docs.microsoft.com/samples/browse/?terms=microsoft%20translator';

export const documentTranslationDocLink = 'https://aka.ms/DocumentTranslationDocs';
export const documentTranslationSampleLink =
    'https://github.com/Azure/azure-sdk-for-python/tree/main/sdk/translation/azure-ai-translation-document/samples';
export const documentTranslationSDKLink =
    'https://docs.microsoft.com/azure/cognitive-services/translator/document-translation/client-sdks?tabs=csharp';

export const taForHealthApiReferenceLink = getLink('taForHealth', 'api');
export const taForHealthDocLink = getLink('taForHealth', 'doc');
export const taForHealthOverviewLink = getLink('taForHealth', 'overview');
export const taForHealthSamplesLink = getLink('taForHealth', 'samples');
export const taForHealthSdkLink = getLink('taForHealth', 'sdk');
export const taForHealthVersionsLink =
    'https://learn.microsoft.com/en-us/azure/cognitive-services/language-service/text-analytics-for-health/how-to/call-api?tabs=ner';

export const summarizationSdkLink = 'https://aka.ms/summerization-sdk';
export const summarizationDocLink = 'https://aka.ms/textsummerization-quickstart';
export const summarizationSamplesLink = 'https://aka.ms/textsummerization-samples';
export const summarizationOverviewLink = 'https://aka.ms/textsummerization-overview';
export const summarizationApiReferenceLink = 'https://aka.ms/textsummerization-apiRefrence';
export const summarizationRequestAccessLink = 'https://aka.ms/applyforgatedsummarizationfeatures';

export const nextStepsDynamicCustomerServiceLink = 'https://learn.microsoft.com/en-us/dynamics365/customer-service/try-customer-service';
export const nextStepsAskQnALink = 'https://aka.ms/studio-microsoft-QA';
export const nextStepsSupportAndHelp =
    'https://learn.microsoft.com/en-us/azure/cognitive-services/cognitive-services-support-options?context=/azure/cognitive-services/language-service/context/context';
